import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { MapaService } from 'src/app/shared/services/mapa.service';

@Injectable({
  providedIn: 'root'
})
export class MapaResolver implements Resolve<boolean> {

  constructor(private service: MapaService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.index();
  }
}

